export default __webpack_public_path__ + "static/media/CallNotification.9dd37b8f.wav";